import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { KalTableGenericDatasource } from 'src/app/_shared/modules/kal-table/kal-table.module';

export class ListingDatasource<T> extends KalTableGenericDatasource<T> {

    protected nbOfElementsValue = 0;

    get nbOfElements(): number {
        return this.isFiltered ? this.rows.length : this.nbOfElementsValue;
    }

    get nbOfElements$(): Observable<number> {
        return this.datasourceRows.pipe(
            map(rows => this.isFiltered ? rows.length : this.nbOfElementsValue)
        );
    }

}
